<template>
<div class="card" style="padding:20px;">
  <div class="row">
    <!--导航-->
    <router-view></router-view>
    <CvViewBar></CvViewBar>
  </div>
</div>
</template>

<script>
    import CvViewBar from "@/components/cv/CvViewBar";
    export default {
        name: "CvView",
        components:{CvViewBar}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/cv/cv_view.vue